import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { CheckCircle2, Loader2, Crown } from "lucide-react";

export default function SubscribeSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userId } = useParams();
  const [status, setStatus] = useState("polling");
  const [data, setData] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    const sid = new URLSearchParams(location.search).get("session_id");
    if (!sid) { navigate(`/u/${userId}`); return; }
    let stopped = false;
    const poll = async () => {
      if (stopped) return;
      if (attempts.current >= 10) { setStatus("timeout"); return; }
      attempts.current += 1;
      try {
        const r = await axios.get(`${API}/checkout/status/${sid}`);
        setData(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
      } catch (e) {
        console.warn("[SubscribeSuccess] poll failed", e);
      }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stopped = true; };
  }, [location, navigate, userId]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="glass-heavy rounded-3xl p-10 text-center grain max-w-md w-full">
        {status === "polling" && (
          <>
            <Loader2 size={48} className="text-[#00E5FF] animate-spin mx-auto" />
            <h2 className="font-display text-2xl font-bold mt-4">Activating your patronage…</h2>
          </>
        )}
        {status === "paid" && (
          <>
            <Crown size={56} className="text-[#F5C542] mx-auto animate-pulse-glow" />
            <h2 className="font-display text-3xl font-bold mt-4">You're a Patron ✦</h2>
            <p className="text-[#64748B] mt-2">
              {data?.metadata?.tier && <>Tier: <span className="text-[#00E5FF] capitalize">{data.metadata.tier}</span> · </>}
              30 days of access
            </p>
            {data?.amount && <div className="font-display text-2xl text-[#00E5FF] mt-3">${Number(data.amount).toFixed(2)}/mo</div>}
            <button data-testid="back-to-creator" onClick={() => navigate(`/u/${userId}`)} className="mt-6 nexus-btn-primary">Back to creator</button>
          </>
        )}
        {(status === "timeout" || status === "expired") && (
          <>
            <CheckCircle2 size={48} className="text-[#F5C542] mx-auto" />
            <h2 className="font-display text-2xl font-bold mt-4">Couldn't confirm</h2>
            <button onClick={() => navigate(`/u/${userId}`)} className="mt-6 nexus-btn-secondary">Back</button>
          </>
        )}
      </div>
    </div>
  );
}
